import { varIsIn } from "common/var";
import {
  Button,
  Col,
  FormItem,
  Input,
  Modal,
  Popconfirm,
  Row,
  Select,
  SuccessNotification,
  message,
} from "components/common";
import { useEffect, useState } from "react";
import { callGetApiWithAuth, callPutApiWithAuth } from "utils/api";
import { Wrapper } from "./EditModal.styled";
import ProductSpackSection from "./ProductSpackSection";

export default function EditSPackModal(props) {
  const [formData, setFormData] = useState({
    quantity: 1,
    // pay_cycle: "",
  });
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [products, setProducts] = useState([]);

  const [containedProducts, setContainedProducts] = useState([]);
  const [spackFilled, setSpackFilled] = useState("");

  const onUpdateDone = (res) => {
    SuccessNotification(res.message);
    setIsUpdating(false);
    props.setShouldLoad(true);
    props.setIsEdition(false);
  };
  const onUpdateFail = () => {
    setIsUpdating(false);
  };
  const handleUpdate = () => {
    // Validation
    if (
      isNaN(formData.quantity) ||
      formData.quantity <= 0 ||
      formData.quantity == ""
    ) {
      message.error("Please input quantity");
      return;
    }

    if (!formData.product_id) {
      message.error("Please select product");
      return;
    }

    if (spackFilled == "Please complete your pack.") {
      message.error("Please complete your pack.");
      return;
    }

    if (
      containedProducts.filter((el) => el.product.is_stockout == 1).length > 0
    ) {
      message.error("Some products are out of stock.");
      return;
    }

    const grouped = Object.values(
      containedProducts.reduce((acc, { product_id, quantity }) => {
        if (!acc[product_id]) {
          acc[product_id] = { product_id, quantity: 0 };
        }
        acc[product_id].quantity += quantity;
        return acc;
      }, {})
    );

    setIsUpdating(true);
    callPutApiWithAuth(
      `my_account/subscription/${props.data.id}`,
      { ...formData, product_id: selectedProduct, contained_products: grouped },
      onUpdateDone,
      onUpdateFail
    );
  };

  useEffect(() => {
    setFormData({
      ...formData,
      quantity: props.data.quantity,
      product_id: props.data.product_id,
    });
    setSelectedProduct(props.data.product.id);
  }, [props.data]);

  useEffect(() => {
    const product = products.find((row) => row.id === selectedProduct);
    if (product?.is_spack !== 1) {
      setSpackFilled("");
      setContainedProducts([]);
    }
  }, [selectedProduct]);

  const onSuccessGetProducts = ({ data }) => {
    setProducts(data);
  };

  const onGetFailedProducts = (err) => {
    setProducts([]);
  };

  const loadProducts = () => {
    callGetApiWithAuth(
      `my_account/subscription/get_physical_products`,
      onSuccessGetProducts,
      onGetFailedProducts
    );
  };

  useEffect(() => {
    loadProducts();
  }, []);

  return (
    <Modal width={480} onCancel={() => props.setIsEdition(false)}>
      <Wrapper>
        <div className="modal-new-title">Edit Subscription Product</div>
        <Row gutter={[20, 10]}>
          {varIsIn("product.type", props.data.product.type, [
            "physical",
            "ticket",
          ]) ? (
            <Col xs={24} sm={24} md={24} xl={12}>
              <div className="products input-form">
                <Select
                  label="Products*"
                  value={selectedProduct}
                  onChange={(value) => setSelectedProduct(value)}
                  size="large"
                  showSearch
                  options={[
                    {
                      value: "",
                      key: "",
                      label: "Select Product",
                    },
                    ...products.map((el) => ({
                      value: el.id,
                      key: el.id,
                      label: el.title,
                    })),
                  ]}
                  optionFilterProp="label"
                />
              </div>
            </Col>
          ) : (
            <Col span={24}>
              <div className="input-container">
                <FormItem>
                  <Input
                    label={"Product name"}
                    value={props.data.product.title}
                    disabled
                  />
                </FormItem>
              </div>
            </Col>
          )}

          {varIsIn("product.type", props.data.product.type, [
            "physical",
            "ticket",
          ]) && (
            <>
              <Col xs={24} sm={12}>
                <div className="input-container">
                  <FormItem>
                    <Input
                      type="number"
                      label={"Quantity"}
                      value={formData.quantity}
                      onChange={(e) =>
                        setFormData({ ...formData, quantity: e.target.value })
                      }
                    />
                  </FormItem>
                </div>
              </Col>
            </>
          )}

          {varIsIn("product.type", props.data.product.type, [
            "physical",
            "ticket",
          ]) && (
            <Col span={24}>
              <ProductSpackSection
                product={products.find((row) => row.id === selectedProduct)}
                setSpackFilled={setSpackFilled}
                setContainedProducts={setContainedProducts}
              />
            </Col>
          )}

          <Col span={24}>
            <div className="action-btn">
              <Button
                className="cancel-btn"
                onClick={() => props.setIsEdition(false)}
              >
                Cancel
              </Button>
              <Popconfirm onConfirm={handleUpdate}>
                <Button loading={isUpdating} className="create-btn">
                  Update Subscription
                </Button>
              </Popconfirm>
            </div>
          </Col>
        </Row>
      </Wrapper>
    </Modal>
  );
}
